import React from 'react'

const DashDispatchsEdit = () => {
  return (
    <div>DashDispatchsEdit</div>
  )
}

export default DashDispatchsEdit